import { AboutModal } from '@ohif/ui-next';
import detect from 'browser-detect';
import React from 'react';

/**
 * OHIF 3.11 replaced `@ohif/ui`'s self-rendering `AboutModal` — which took
 * `versionNumber`/`commitHash` and built its own rows — with a presentational
 * compound component in `@ohif/ui-next` that only renders its `children`.
 *
 * `uiModalService.show()` renders `<Content {...contentProps} />` with no
 * children, so pointing the menu entry straight at ui-next's `AboutModal` opens
 * an EMPTY modal (no error, no warning). This composes the content instead,
 * mirroring upstream's `ohif.aboutModal` customization.
 */

type GdataAboutModalProps = {
  versionNumber?: string;
  commitHash?: string;
};

export function GdataAboutModal({
  versionNumber,
  commitHash,
}: GdataAboutModalProps) {
  const { os, version, name } = detect();
  const browser = name
    ? `${name[0].toUpperCase()}${name.substr(1)} ${version}`
    : 'Unknown';

  const [main, beta] = (versionNumber ?? '').split('-');

  return (
    <AboutModal className="w-[400px]">
      <AboutModal.ProductName>GData Viewer</AboutModal.ProductName>
      <AboutModal.ProductVersion>{main}</AboutModal.ProductVersion>
      {beta && <AboutModal.ProductBeta>{beta}</AboutModal.ProductBeta>}

      <AboutModal.Body>
        <AboutModal.DetailItem
          label="Commit Hash"
          value={commitHash}
        />
        <AboutModal.DetailItem
          label="Current Browser & OS"
          value={`${browser}, ${os}`}
        />
      </AboutModal.Body>
    </AboutModal>
  );
}

export default GdataAboutModal;
